export const REGEXP_HTML_TAG = /(<([^>]+)>)/gi;
